module.exports = __webpack_public_path__ + "img/2-fr.4d1d8c51.jpg";